<div [ngClass]="{'error-container-overlay': overlay}">
  <div class="error-container" role="alert" *ngIf="error">
    <div class="error-header" *ngIf="errorHeader">{{errorHeader}}</div>
    <div>{{errorMessage}}</div>
    <a *ngIf="showTryAgain" (click)="tryAgainClicked()">{{tryAgainText}}</a>
    <ng-content></ng-content>
  </div>
</div>
